'use client';
import { useParams } from 'next/navigation';
import React, { useState } from 'react';

import { Text } from '~components/Typography';
import { usePaywallContext } from '~context/paywall';
import { PaymentReason } from '~features/annals/enums/payment';
import annalsCheckout from '~features/annals/hooks/checkout';
import annalsNavigation from '~features/annals/hooks/navigation';
import { useTranslations } from '~i18n/hooks';
import DiamondIcon from '~public/assets/icons/navigation/dimond.svg';
import { DropdownElement } from '~shared/ui/atoms/Dropdown';
import { MySubscriptions, useSubscriptions } from '~widgets/MySubscriptions';

export const MySubscriptionsItem = () => {
	const { recipientId: botClientId } = useParams<{ recipientId?: string }>();
	const t = useTranslations('ProfileMenu');

	const [isOpen, setIsOpen] = useState(false);

	const { openPaywall } = usePaywallContext();
	const { activeSubscription } = useSubscriptions();

	const reasonType = annalsCheckout.usePaymentReasonType();
	const sendClick = annalsNavigation.useNavTopMySubscriptionButtonClicked();

	return (
		<>
			<DropdownElement
				data-name="subscription-item"
				icon={<DiamondIcon />}
				onClick={() => {
					sendClick();
					if (activeSubscription) {
						setIsOpen(true);
					} else {
						openPaywall({
							reason: PaymentReason.LeftMenu,
							reasonType,
							prefer: 'subscription',
							botClientId,
						})();
					}
				}}
			>
				<Text size="M" align="left">
					{t('subscriptionTitle')}
				</Text>
			</DropdownElement>

			{isOpen && (
				<MySubscriptions
					activeSubscription={activeSubscription}
					onClose={() => setIsOpen(false)}
				/>
			)}
		</>
	);
};
